import './App.css';
import '@rainbow-me/rainbowkit/styles.css';

import Heropage from './components/Heropage/Heropage';
import About from './components/About/About';
import Direction from './components/Direction/Direction';
import Roadmap from './components/Roadmap/Roadmap';
import Tokenomics from './components/Tokenomics/Tokenomics';
import FAQ from './components/FAQ/FAQ';
import Footer from './components/Footer/Footer';


// import Heropage from './components/2/Heropage';
// import About from './components/2/About';
// import Direction from './components/2/Direction';
// import Roadmap from './components/2/Roadmap';
// import Tokenomics from './components/2/Tokenomics';
// import FAQ from './components/2/FAQ';
// import Footer from './components/2/Footer';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WagmiProvider } from 'wagmi';
import {
  arbitrum,
  base,
  mainnet,
  optimism,
  polygon,
  sepolia,
} from 'wagmi/chains';
import { getDefaultConfig, RainbowKitProvider } from '@rainbow-me/rainbowkit';

const config = getDefaultConfig({
  appName: 'RainbowKit App',
  projectId: 'YOUR_PROJECT_ID',
  chains: [
    mainnet,
    polygon,
    optimism,
    arbitrum,
    base,
    ...(process.env.NEXT_PUBLIC_ENABLE_TESTNETS === 'true' ? [sepolia] : []),
  ],
  ssr: true,
});

const client = new QueryClient();

function App() {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={client}>
        <RainbowKitProvider>
        <div>
          <Heropage/>
          <About/>
          <Direction/>
          <Roadmap/>
          <Tokenomics/>
          <FAQ/>
          <Footer/>
        </div>
    </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export default App;
